// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchCuratedCollectionItemIDsParams = {
    collectionID: any,
    deployment: string,
};

export default {
    fetchCuratedCollectionItemIDs: ({ collectionID, deployment }: FetchCuratedCollectionItemIDsParams) =>
        new Promise<any>((resolve, reject) => {
            let searchString = `<COLLECTION-API>?collection_id=${collectionID}`;

            const request = makeGet({ apiPath: 'getcollection', deployment, path: searchString });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
